import fanzaLogo from '../assets/fanza-logo.png';
import type { MenuSection } from '../menu.js';

const BANANA = '바나나몰';

export type SectionBrand = 'fanza' | 'banana';

/**
 * 섹션의 구분색 이름. 상단바(topbar--*)·첫 화면 카드(menu-card--*) 클래스
 * 접미사로 쓰고, 색 자체는 styles.css 의 --fanza / --banana 토큰에 있다.
 * title 이 아니라 안 바뀌는 key 로 고른다(MenuSection 주석 참고).
 */
export function sectionBrand(section: MenuSection): SectionBrand | undefined {
  if (section.key === 'lottery') return 'fanza';
  if (section.key === 'randombox') return 'banana';
  return undefined;
}

/**
 * 메뉴 섹션 이름. 상단바(Layout)와 첫 화면 카드 제목(HomePage)이 같이 쓴다.
 *
 * 2026-11-03 요청: 이름이 비슷한 두 랜덤박스 섹션을 눈으로 바로 구분하게 한다.
 *  - '랜덤박스'(key lottery, FANZA 쪽)는 이름 앞에 FANZA 로고를 붙인다.
 *  - '바나나몰 랜덤박스'(key randombox)는 '바나나몰'만 노란색으로 칠한다.
 *  - 같은 날 추가 요청으로 두 섹션의 상단바·카드 배경도 섹션 색으로 옅게
 *    물들였다(sectionBrand, styles.css).
 * menu.ts 의 title 문자열은 그대로 둔다 - aria-label·권한 없음 안내·테스트가
 * 그 문자열을 쓴다.
 */
export function SectionTitle({ section }: { section: MenuSection }) {
  const brand = sectionBrand(section);

  if (brand === 'fanza') {
    return (
      <>
        <img src={fanzaLogo} alt="FANZA" className="section-title__logo" /> {section.title}
      </>
    );
  }

  if (brand === 'banana' && section.title.startsWith(BANANA)) {
    return (
      <>
        <span className="section-title__banana">{BANANA}</span>
        {section.title.slice(BANANA.length)}
      </>
    );
  }

  return <>{section.title}</>;
}
